
export class LocalStore {

    public static setValue(key: string, value: string) {
        localStorage.setItem(key, value)
    }

    public static getValue(key: string) {
        return localStorage.getItem(key)
    }

    public static deleteKey(key: string) {
        return localStorage.removeItem(key)
    }

}